import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';

import CustomizedTable from '../CSSComponent/table'

import { extractData } from '../../util/TableUtil'
import { styles } from '../CSS/Styles';

class ActionPlan extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: 0,
            filter: [],
            isFilterByStatus: false,
            isFilterByType: false,
            isFilterByRisk: false
        }
    }

    componentDidMount() {
    }

    componentWillMount() {
        //this.setState(getState());
        //setInterval(() => {
        //    this.setState(getState());
        //}, 4000);
        this.getFilter()
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked })
    };

    getFilter() {
        let filterData = {
            'Status': ['On Track', 'Delayed', 'Completed'],
            'Type': ['New', 'Enhance'],
            'Risk': ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9'],
        }
        this.setState( { filter: filterData } )
        for (let val in filterData) {
            let data = filterData[val]
            for (let filter in data) {
                this.setState({ [data[filter]]: true })
            }
        }
    }

    render() {
        const { classes } = this.props
        const filters = ()=>{
            let filterJSX = []
            for (var filter in this.state.filter) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '120px'}}> {filter} : </typography>
                        {this.state.filter[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data]}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const filterheader = filters()
        let apData = []
        let data = this.props.data
        const headers = ['No', 'Risk', 'Reference', 'Action Plan', 'Owner(s)', 'Type', 'Status', 'Timeline']
        const dbheader = ['risk_name', 'risk_name', 'action_plans_no', 'summary_of_action_plans', 'action_plans_owner', 'action_type', 'implementation_status', 'timeline']
        for (let keys in data) {
            apData = apData.concat(data[keys]['actions'])
        }
        
        let tableData = extractData(apData, headers, dbheader)
        console.log(tableData)

        return (
            <div flexGrow={1}>
                {filterheader}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card className={classes.card_fit_content}>
                            <CardContent className={classes.content}>
                                <CustomizedTable
                                    tableHeader = {headers}
                                    data = {tableData}
                                    searchBar={true}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(ActionPlan);


// WEBPACK FOOTER //
// ./src/components/Dashboard/ERMActionPlanDashboard.js